<template>
  <b-modal
    :id="`responsible-squads-modal`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    @hidden="hidden"
  >

    <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>Definir squad responsável</span>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="mt-2">
        <form class="default-form" @submit.prevent="">
          <div v-if="usersLoader">
            <Loader
              :size="'small'"
              :align="'start'"
            />
          </div>
          <div v-else>
            <Multiselect
              id="users"
              v-model="form.users"
              placeholder="Procurar"
              label="label"
              track-by="code"
              :options="usersOptions"
              :multiple="true"
            />
          </div>

          <div class="d-flex justify-content-around mt-3">
            <Button
              class="btn btn-primary"
              @click="submit"
              :loading="loader"
            >
              Enviar
            </Button>
          </div>
        </form>
    </div>
  </b-modal>
</template>

<script>

import ResponsibleSquadsService from '@/modules/responsible-squads/services/responsible-squads-service'
import UsersService from '@/modules/users/services/users-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ResponsibleSquadsModal',
  props: ['companyId'],
  components: {
    AlertWraper,
    Button,
    Multiselect
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false,
      usersLoader: false,
      form: {
        users: [],
        advertiser_id: '',
        company_id: ''
      },
      users: []
    }
  },
  created () {
    this.getUsers()
  },
  computed: {
    /**
     * Get users options
     */
    usersOptions () {
      return this.users.map(item => {
        return {
          label: item.name,
          code: item.id
        }
      })
    }
  },
  methods: {
    /**
     * Get users
    */
    async getUsers () {
      try {
        const users = await UsersService.getUsers({
          order_by: 'name',
          role: 'administrator',
          sort: 'ASC',
          items_per_page: 50,
          is_active: 1
        })
        this.users = users.data
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    /**
     * On modal hidden
     */
    hidden () {
      this.content = null
    },
    /**
     * Submit form
     */
    async submit () {
      this.loader = true
      const form = JSON.parse(JSON.stringify(this.form))

      if (this.companyId) {
        form.company_id = this.companyId
      }

      form.users = this.form.users.map(state => {
        return state.code
      })

      try {
        await ResponsibleSquadsService.createResponsibleSquad(form)
        this.$bvModal.hide('responsible-squads-modal')

        const notification = {
          notification: {
            type: 'success',
            content: 'Responsáveis salvos com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('created')
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }

      this.loader = false
    }
  }
}
</script>

<style lang="css" src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
